module.exports = __webpack_public_path__ + "img/65A.d5eefbc7.png";